import { render, staticRenderFns } from "./BotManageTasks.vue?vue&type=template&id=8b87f2d2&"
import script from "./BotManageTasks.vue?vue&type=script&lang=js&"
export * from "./BotManageTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports